import React, { ReactNode, useCallback, useRef } from "react";
import styles from "./Map.module.scss";
import { GoogleMap } from "@react-google-maps/api";
import { defaultMapOptions } from "./themeMap";
import { useNavigate } from "react-router-dom";

const containerStyle = {
  width: "100%",
  height: "100%",
};

interface MapProps {
  center: { lat: number; lng: number };
  children: ReactNode;
}

const Map: React.FC<MapProps> = ({ center, children }) => {
  const mapRef = useRef<any>(null);
  const onLoad = useCallback((map: any) => {
    mapRef.current = map;
  }, []);

  const onUnmount = useCallback(() => {
    mapRef.current = null;
  }, []);

  return (
    <div className={styles.container}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={7}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={defaultMapOptions}
      >
        {children}
      </GoogleMap>
    </div>
  );
};

export default Map;
